import React, { useState, useEffect, useRef } from "react";
import CustomGrid from "../CustomComponents/CustomGrid/CustomGrid";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import CustomHorizontalBarChart from "../CustomComponents/CustomHorizontalBarChart/CustomHorizontalBarChart";
import CustomCircularProgress from "../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { useStyles } from "../../assets/jss/Events";
import clsx from "clsx";
import {
  getEventType,
  getUserData,
  getSession,
  getUserRBAC,
  isShowEventDetails,
  setCorneringEventIndex,
  getCorneringEventIndex,
  setIsCameFromEventDetailsPage,
  getIsCameFromEventDetailsPage,
} from "../../services/LocalStorageService";
import trackEvents from "../../assets/appInsightsEvents";
import { EventCode, RBAC_CODE, TableComponentCodes } from "../../config/app-globals.enum";

import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getEventsSummary } from "../../services/EventsSummary";
import { useTranslation } from "react-i18next";
import PraisoTableWrapper from "../../components/CustomComponents/PraisoTable/PraisoTableWrapper";
import { useParams } from "react-router-dom";
export default function CorneringTab(props: any) {
  const params = useParams();

  const { t } = useTranslation();
  const classes = useStyles();
  const [] = React.useState(
    getUserRBAC(RBAC_CODE.USER_DETAIL_VIEW, props)
  );
  const [userSession] = useState(getSession);
  const [pageLength, setPageLength] = useState(0);
  const [pageLengthArray, setPageLengthArray] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(0);
  const [] = React.useState(getUserData);
  const [eventTypes] = React.useState(getEventType);
  const [isVisibleEventDtls] = React.useState(isShowEventDetails(EventCode.CORNERING));
  const [defaultFilterBy, setDefaultFilterBy] = React.useState({
    eventTypeId: null,
  });
  const [corneringEvent, setCorneringEvent] = React.useState(null);
  const [corneringChildEvents, setCorneringChildEvents] = React.useState(null);
  const [corneringChildEventCount, setCorneringChildEventCount] =
    React.useState(null);
  const [corneringChildEventsLabel, setCorneringChildEventslabel] =
    React.useState([]);
  const [userList, setUserList] = React.useState([]);
  const [graphData, setGraphData] = useState({
    data: {
      labels: [],
      datasets: []
    },
    corneringReport: {},
    loading: false,
    selectedBar: 0,
  });
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [] = useState(false);

  const [corneringData, setCorneringData] = useState({
    loading: true,
    currentData: [],
  });
  const [isApi, setIsApi] = useState(false);


  useEffect(() => {
    setPage(0);
  }, [graphData.selectedBar]);

  useEffect(() => {
    if (userSession) {
      setPageLength(userSession.pageLength);
    }
  }, [userSession]);

  useEffect(() => {
    if (pageLength) {
      /** @todo: pagination array need to be dynamic */
      // const pageArray = [
      //   pageLength,
      //   pageLength * 2,
      //   pageLength * 5,
      //   pageLength * 10,
      //   pageLength * 20,
      // ];
      const pageArray = [10, 100, 500];
      // setRowsPerPage(pageLength);
      setRowsPerPage(10);
      setPageLengthArray(pageArray);
    }
  }, [pageLength]);

  //====
  const [statusValue, setStatusValue] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState("");
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);
  const changeApiStatusCodeFunc = (status) => {
    if (status.code && status.code !== 0 && status.code !== 200) {
      setStatusValue(status.code);
      setAlertMessage(
        status.message
          ? status.message
          : `${t("SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER")}`
      );
      setIsAlertOpen(true);
    }
  };
  //====
  useEffect(() => {
    if (eventTypes && eventTypes.length > 0) {
      const corneringEventObj = eventTypes.find(
        (event) => event.code === "CORNERING"
      );
      setCorneringEvent(corneringEventObj);
    }
  }, [eventTypes]);
  //====
  //====
  useEffect(() => {
    if (corneringEvent) {
      const corneringChildEventsArray = eventTypes.filter(
        (event) => event.parentEventTypeId === corneringEvent.id
      );
      setCorneringChildEvents(corneringChildEventsArray);
    }
  }, [corneringEvent]);
  //====
  useEffect(() => {
    if (corneringChildEvents && corneringChildEvents.length > 0) {
      const labels = [];
      for (const event of corneringChildEvents) {
        labels.push(event.name);
      }
      setCorneringChildEventslabel(labels);
    }
  }, [corneringChildEvents]);
  //====
  //====

  const mounted = useRef(false);
  useEffect(()=>{
    mounted.current = true;
    if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 0) {
      setCorneringEventIndex(-1);
    }
    return () => {
      mounted.current = false;
      if (getIsCameFromEventDetailsPage() !== undefined && getIsCameFromEventDetailsPage() !== null && getIsCameFromEventDetailsPage() === 1) {
          setIsCameFromEventDetailsPage(0);
      }
  };
  },[]);

  async function loadData() {
    let selectedBarIndex = 0;
    if (getCorneringEventIndex() !== undefined && getCorneringEventIndex() !== null && getCorneringEventIndex() !== -1) {
      selectedBarIndex = getCorneringEventIndex();
    }
    setStatusValue(null);
    setAlertMessage("");
    setIsApi(true);
    setIsAlertOpen(false);
    const data = await getEventsSummary({ eventTypeId: corneringEvent.id }, params);
    if (
      data &&
      (data.status.code === 0 ||
        data.status.code === 200 ||
        data.status.code === 201) &&
      data.content
    ) {
      data.content.eventStatus === 1 ? setEventStatus(true) : setEventStatus(false);
      setIsApi(false);
      const eventCount = [];
      for (const event of corneringChildEvents) {
        const eventItem = data.content.eventCounts.find(
          (item) => item.eventTypeId === event.id
        );
        if (eventItem) {
          eventCount.push(eventItem.eventCount);
        } else {
          eventCount.push(0);
        }
      }
      const filteredByEventId = data.content.eventDetails.filter(
        (item) => item.eventTypeId === corneringChildEvents[selectedBarIndex].id
      );
      setCorneringChildEventCount(eventCount);
      setDefaultFilterBy({
        ...defaultFilterBy,
        eventTypeId: corneringChildEvents[selectedBarIndex].id,
      });
      setUserList(data.content.eventDetails);
      setCorneringData({
        ...corneringData,
        currentData: filteredByEventId,
        loading: false,
      });
      setGraphData({
        ...graphData,
        corneringReport: data.content,
        selectedBar:selectedBarIndex
      });
    } else {
      setIsApi(true);
      setIsApiFailed(true);
      const staticGraph = {
        ExcessSpeedCount: 198,
        FastApproachCount: 0,
        PoorTechniqueCount: 8,
        ApiRootPath: "/api/",
        StartDate: "2020-10-16T01:03:18.0163567+01:00",
        EndDate: "2020-11-06T01:03:18.0163567+00:00",
        MaxEventsPerPage: 100,
        TelematicsProvider: 0,
      };
      setGraphData({
        ...graphData,
        loading: false,
        corneringReport: staticGraph,
      });
      changeApiStatusCodeFunc(data.status);
    }
  }

  const [eventStatus, setEventStatus] = useState(false);
  useEffect(() => {
    if (corneringChildEvents && graphData) {

      loadData();
    }
  }, [corneringChildEvents]);

  useEffect(() => {
    if (
      graphData.selectedBar !== null &&
      graphData.selectedBar !== undefined &&
      corneringChildEvents
      // &&
      // userList &&
      // userList.length > 0
    ) {
      // const filteredByEventId = userList.filter(
      //   (item) =>
      //     item.eventTypeId === corneringChildEvents[graphData.selectedBar].id
      // );
      setDefaultFilterBy({
        ...defaultFilterBy,
        eventTypeId: corneringChildEvents[graphData.selectedBar].id,
      });
      setCorneringData({
        ...corneringData,
        // currentData: filteredByEventId,
        currentData: [],
        loading: false,
      });
    }
  }, [graphData.selectedBar]);

  useEffect(() => {
    if (
      graphData.corneringReport &&
      graphData.selectedBar !== null &&
      graphData.selectedBar !== undefined &&
      corneringChildEventCount
    ) {
      const bgColor = corneringChildEventCount.map((dt, index) => {
        let color =
          graphData.selectedBar === index
            ? isApiFailed
              ? "rgb(241, 242, 246)"
              : "rgba(46, 91, 255, 1)"
            : isApiFailed
              ? "rgb(241, 242, 246)"
              : "rgba(46, 91, 255, 0.3)";
        return color;
      });
      setGraphData({
        ...graphData,
        data: {
          labels: corneringChildEventsLabel,
          datasets: [
            {
              label: t("CORNERING_EVENTS"),
              barPercentage: 0.5,
              barThickness: 20,
              borderWidth: isApiFailed ? 0 : 1,
              maxBarThickness: 20,
              minBarLength: 2,
              data: corneringChildEventCount,
              backgroundColor: bgColor,
            },
          ],
        },
      });
    }
  }, [graphData.corneringReport, graphData.selectedBar]);

  //====
  const [statusValue1, setStatusValue1] = React.useState();
  const [alertMessage1, setAlertMessage1] = React.useState("");
  const [isAlertOpen1, setIsAlertOpen1] = React.useState(false);

  //Filter API reponse for Event type
  const [filteredTableData, setFilteredTableData] = useState([]);

  async function getFilteredTableData(isFreshCall?: boolean) {
    let filteredData = [];
    for (let i = 0; i < userList.length; i++) {

      if (userList[i].eventTypeId === defaultFilterBy.eventTypeId) {
        filteredData.push(userList[i]);
      }
    }
    setFilteredTableData(filteredData);
  }

  useEffect(() => {
    getFilteredTableData();
  }, [defaultFilterBy, userList]);

  return (
    <>
      <CustomGrid container spacing={4} justifyContent="space-between">
        <CustomGrid item xs={12}>
          <CustomPaper square elevation={0}>
          {isApi ? (
              <CustomCard
                elevation={0}
                className={clsx(
                  classes.cardContentWrapper,
                  classes.cardContentWrapperCenter
                )}
              >
                {isApi && (
                  <CustomPaper
                    className={classes.loadingContainer}
                    elevation={0}
                  >
                    <CustomCircularProgress />
                  </CustomPaper>
                )}
              </CustomCard>
            ) : null}
            {!isApi ? (
              <CustomCard
                elevation={0}
                className={clsx(
                  classes.cardContentWrapper,
                  isApiFailed ? classes.graphDisabled : null
                )}
              >
                {Object.keys(graphData.corneringReport).length === 0 && (
                  <CustomPaper className={classes.loadingContainer} elevation={0}>
                    <CustomCircularProgress />
                  </CustomPaper>
                )}
                {Object.keys(graphData.corneringReport).length !== 0 && (
                  <CustomCardContent
                    className={clsx(
                      classes.cardContent,
                      isApiFailed ? classes.cardContentDisabled : null
                    )}
                    style={{ padding: "1.5em 3em" }}
                  >
                    <CustomGrid container>
                      <CustomGrid item xs={12}>
                        <CustomHorizontalBarChart
                          className={classes.reportGraph}
                          data={graphData.data}
                          options={{
                            legend: { display: false },
                            scales: {
                              xAxes: [
                                {
                                  ticks: { beginAtZero: true },
                                  gridLines: { display: false },
                                },
                              ],
                              yAxes: [
                                {
                                  ticks: { beginAtZero: true },
                                  gridLines: { display: false },
                                },
                              ],
                            },
                            onClick: (e, item) => {
                              if (item.length !== 0) {
                                trackEvents("Event", {
                                  name: "Cornering",
                                  value: graphData.data.labels[item[0]["_index"]],
                                }, params);
                              }
                              item &&
                                item[0] &&
                                setGraphData({
                                  ...graphData,
                                  selectedBar: item[0]["_index"],
                                });
                                setCorneringEventIndex(item[0]["_index"]);
                            },
                          }}
                          height={70}
                        />
                      </CustomGrid>
                    </CustomGrid>
                  </CustomCardContent>
                )}
              </CustomCard>
            ) : null}
          </CustomPaper>
        </CustomGrid>
      </CustomGrid>
      <CustomGrid container spacing={4} justifyContent="space-between">
        <CustomGrid item xs={12} className={classes.cardContentWrapper}>
          {corneringEvent && !isApi && isVisibleEventDtls ? (
            <PraisoTableWrapper
              // getTableSettingAPI="/tableSettingApi"
              // getTableSettingAPI="user-table-component-mapping?tcId=10"
              // tableSettingView="ceul"
              getTableSettingAPI={`user-table-component-mapping/v1/fetchAll?tcCode=${TableComponentCodes.CORNERING_EVENT_USER_LIST}`}
              tableSettingView={TableComponentCodes.CORNERING_EVENT_USER_LIST}
              preFetchedTableData={filteredTableData}
              callBackFun={loadData}
              // getTableDataAPI={`insights/event-details/${corneringEvent.id}`}
              // getTableDataApiParam={{
              //   eventTypeId: corneringEvent.id,
              //   sentBy: "kamalesh",
              // }}
              // tableDataApiResponseProperty="eventDetails"
              // defaultFilterBy={defaultFilterBy}
              // updateCurrentLimitedRow={showLimitedDriver}
              // showMoreOrLessComp={
              //   getRBAC_WOL_Show_Limited &&
              //   getRBAC_WOL_Show_Limited.isAccessible === EntityAccess.ALLOWED ? (
              //     <ShowMoreOrLess
              //       updateShowMoreStatus={(currentLabel) =>
              //         setShowLimitedDriver(currentLabel)
              //       }
              //       setShowMoreStatus={showLimitedDriver}
              //     />
              //   ) : null
              // }
              {...props}
            />
          ) : null}
          {/*           
          <CustomTableContainer component={CustomPaper} elevation={0}>
            <CustomTable className={classes.table}>
              <CustomTableHead>
                <CustomTableRow className={classes.bgWhite}>
                  <CustomTableCell style={{ width: "50%" }}>
                    <CustomTypography
                      paragraph={true}
                      className={classes.title}
                    >
                      {t("OCCURRED_AT")}
                    </CustomTypography>
                  </CustomTableCell>
                  <CustomTableCell style={{ width: "50%" }}>
                    <CustomTypography
                      paragraph={true}
                      className={classes.title}
                    >
                      {t("DRIVER_NAME")}
                    </CustomTypography>
                  </CustomTableCell>
                </CustomTableRow>
              </CustomTableHead>
              <CustomTableBody>
                {corneringData.loading === true && (
                  <CustomTableRow className={classes.bgWhite}>
                    <CustomTableCell
                      scope="row"
                      colspan="2"
                      className={clsx(
                        classes.marker,
                        classes.tableBodyContainer
                      )}
                    >
                      <CustomPaper
                        className={classes.loadingContainer}
                        elevation={0}
                      >
                        <CustomCircularProgress
                          className={classes.circularProgressSmall}
                        />
                      </CustomPaper>
                    </CustomTableCell>
                    <CustomTableCell />
                  </CustomTableRow>
                )}

                {corneringData.loading === false &&
                  corneringData.currentData.length === 0 &&
                  !tableApiFailed && (
                    <CustomTableRow className={classes.bgWhite}>
                      <CustomTableCell
                        scope="row"
                        className={clsx(
                          classes.marker,
                          classes.tableBodyContainer
                        )}
                      >
                        <CustomBox className={classes.tableCellValue}>
                          {t("NO_RECORDS_FOUND")}.
                        </CustomBox>
                      </CustomTableCell>
                      <CustomTableCell />
                    </CustomTableRow>
                  )}
                {corneringData.currentData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((event, index) => (
                    <>
                      <CustomTableRow
                        className={classes.bgWhite}
                        key={`event-${index}`}
                      >
                        <CustomTableCell
                          scope="row"
                          className={clsx(
                            classes.marker,
                            classes.tableBodyContainer
                          )}
                        >
                          <CustomBox className={classes.tableCellValue}>
                            <div className={classes.eventDateValue}>
                              <DateTime
                                inputDate={event.occurredAt}
                                returnFormat="ddd"
                              />
                              ,{" "}
                              <DateTime
                                inputDate={event.occurredAt}
                                returnFormat="DD MMM YYYY"
                              />
                            </div>
                            <div className={classes.occurredAt}>
                              <DateTime
                                inputDate={event.occurredAt}
                                returnFormat="hh:mm:ss a"
                              />
                            </div>
                          </CustomBox>
                        </CustomTableCell>
                        <CustomTableCell>
                          <CustomBox className={classes.tableCellValue}>
                            {getRBAC_UserDetailView &&
                            getRBAC_UserDetailView.isAccessible === EntityAccess.ALLOWED &&
                            (getRBAC_UserDetailView.isGroupScope === EntityAccess.ALLOWED ||
                              event.userId === userData.id) ? (
                              <Link
                                to={{
                                  pathname: `/userdetails/${event.userId}`,
                                  state: {
                                    userId: event.userId,
                                    tabValue: 1,
                                    showTab: "Cornering",
                                  },
                                }}
                              >
                                {titleCase(event.userName)}
                              </Link>
                            ) : (
                              titleCase(event.userName)
                            )}
                            
                          </CustomBox>
                        </CustomTableCell>
                      </CustomTableRow>
                    </>
                  ))}
                {tableApiFailed && (
                  <>
                    <CustomTableRow className={classes.bgWhite}>
                      <CustomTableCell
                        scope="row"
                        className={clsx(
                          classes.marker,
                          classes.tableBodyContainer
                        )}
                      >
                        <CustomBox className={classes.tableCellValue}>
                          <CustomSkeleton
                            className={classes.scoreValueSkeleton}
                            animation="wave"
                            width={100}
                            height={60}
                          />
                        </CustomBox>
                      </CustomTableCell>
                      <CustomTableCell>
                        <CustomBox className={classes.tableCellValue}>
                          <CustomSkeleton
                            className={classes.scoreValueSkeleton}
                            animation="wave"
                            width={100}
                            height={60}
                          />
                        </CustomBox>
                      </CustomTableCell>
                    </CustomTableRow>
                  </>
                )}
              </CustomTableBody>
              {corneringData.currentData &&
              corneringData.currentData.length &&
              pageLengthArray ? (
                <CustomTableFooter className={classes.tableFooter}>
                  <CustomTableRow>
                    <CustomTablePagination
                      className={classes.tablePagination}
                      rowsPerPageOptions={pageLengthArray}
                      count={corneringData.currentData.length}
                      rowsPerPage={rowsPerPage}
                      labelRowsPerPage={t("ROW_PER_PAGE")}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </CustomTableRow>
                </CustomTableFooter>
              ) : null}
            </CustomTable>
          </CustomTableContainer>
         */}
        </CustomGrid>
      </CustomGrid>
      <ErrorAlert
        code={statusValue}
        message={alertMessage}
        isOpen={isAlertOpen}
        isClose={(isClose) => setIsAlertOpen(!isClose)}
      />
      <ErrorAlert
        code={statusValue1}
        message={alertMessage1}
        isOpen={isAlertOpen1}
        isClose={(isClose) => setIsAlertOpen1(!isClose)}
      />
    </>
  );
}
